<template>
  <div id="app">
   <component :is="layout">
    <router-view></router-view>
   </component>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode';
import authApi from '@/apis/auth-api';
import axios from 'axios';
import EventBus from '@/events/event-bus';

export default {
  name: 'app',
  computed: {
    layout() {
      return this.$route.meta.layout || 'simple';
    }
  },
  data() {
    return {
      user: []
    };
  },
  created() {
    // axios.defaults.baseURL = 'http://api.uther.com/api';
    axios.defaults.baseURL = 'http://api.michelepauty.com/api';
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    // axios.defaults.headers.common['Content-type'] = "application/json";
    axios.interceptors.response.use(
      (response) => {
        if (response.data.alert) {
          EventBus.$emit('showAlert', response.data.message);
        }
        return response;
      },
      (error) => {
        if (error.response.status === 401) {
          // next({ path: 'signin' });
        }
        return error;
      }
    );
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue